<template>
  <div>
    <div class="row">
      <div class="col-lg-8">
        <div class="card">
          <div class="card-body">
            <div class="mb-3">
              <label for="notif-module">Module<span class="text-danger">*</span></label>
              <multiselect
                v-model="notification.module"
                :options="moduleOptions"
                track-by="value"
                label="value"
                select-label="Click to select"
                deselect-label="Click to remove"
                placeholder="Select Module"
                :allow-empty="true"
                :taggable="true" 
                @tag="addTag"
                :class="{ 'is-invalid': !$v.notification.module.required && submitted }"
              ></multiselect>
              <p class="small text-danger mb-0" v-if="!$v.notification.module.required && submitted">Module is required</p>
            </div>
            <div class="mb-3">
              <label for="notif-name">Name<span class="text-danger">*</span></label>
              <input
                type="text"
                class="form-control"
                v-model="notification.name"
                id="notif-name"
                placeholder="Enter Name"
                :class="{ 'is-invalid': !$v.notification.name.required && submitted }"
              />
              <!-- <p class="small text-danger mb-0" v-if="!$v.notification.name.required && submitted">Name is required</p> -->
            </div>
            <div class="mb-3">
              <label for="notif-sms-content">SMS Content</label>
              <div class="form-check form-switch form-switch-md float-end mr-3">
                <label class="form-check-label form-label small" for="customSwitchsizem">{{
                  notification.smsStatus ? "Enabled" : "Disabled"
                }}</label>
                <input type="checkbox" class="form-check-input" id="customSwitchsizem" v-model="notification.smsStatus" />
              </div>
              <b-form-textarea
                type="text"
                class="form-control"
                v-model="notification.smsContent"
                rows="10"
                id="notif-sms-content"
                placeholder="Enter SMS Content"
              ></b-form-textarea>
              <!-- <p class="small text-danger mb-0" v-if="!$v.notification.smsContent.required && submitted">SMS Content is required</p> -->
            </div>
            <div class="mb-3">
              <label for="notif-sms-settings">SMS Settings</label>
              <b-form-textarea
                type="text"
                class="form-control"
                v-model="notification.smsSettings"
                rows="10"
                id="notif-sms-settings"
                placeholder="Enter SMS Settings"
              ></b-form-textarea>
              <!-- <p class="small text-danger mb-0" v-if="!$v.notification.smsSettings.required && submitted">SMS Settings is required</p> -->
            </div>
            <div class="mb-3">
              <label for="notif-app-inbox-content">App Inbox Content</label>
              <div class="form-check form-switch form-switch-md float-end mr-3">
                <label class="form-check-label form-label small" for="customSwitchsizem">{{
                  notification.appInboxStatus ? "Enabled" : "Disabled"
                }}</label>
                <input type="checkbox" class="form-check-input" id="customSwitchsizem" v-model="notification.appInboxStatus" />
              </div>
              <b-form-textarea
                type="text"
                class="form-control"
                v-model="notification.appInboxContent"
                rows="10"
                id="notif-app-inbox-content"
                placeholder="Enter App Inbox Content"
              ></b-form-textarea>
              <!-- <p class="small text-danger mb-0" v-if="!$v.notification.appInboxContent.required && submitted">
                App Inbox Content is required
              </p> -->
            </div>
            <div class="d-flex align-items-center">
              <div class="ms-auto">
                <button class="btn btn-primary me-3" style="width: 170px" @click="submitNotification()">Submit</button>
                <router-link :to="{ name: 'Notification Dashboard' }" class="tc-white">
                  <b-button variant="light" class="w-sm" type="button" style="width: 170px">Cancel</b-button>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { layoutMethods, peddlrNotificationMethods, peddlrNotificationComputed } from "@/state/helpers";
import { required } from "vuelidate/lib/validators";
import Swal from "sweetalert2";
import Multiselect from "vue-multiselect";

export default {
  page: {
    title: "Notification Form",
  },
  validations: {
    notification: {
      module: { required },
      name: { required },
    //   smsContent: { required },
    //   smsStatus: { required },
    //   appInboxContent: { required },
    //   appInboxStatus: { required },
    },
  },
  data() {
    return {
      totalRows: 0,
      submitted: false,
      notification: {
        id: 0,
        module: "",
        name: "",
        smsContent: "",
        appInboxContent: "",
        smsStatus: false,
        appInboxStatus: false,
        smsSettings: "",
      },
      action: "",
    };
  },
  components: {
    Multiselect,
  },
  computed: {
    ...peddlrNotificationComputed,
    moduleOptions: {
      get(){
        return this.peddlrNotificationModules.map(item => {
          return { 'value': item.module }
        });
      }
    },
  },
  methods: {
    ...layoutMethods,
    ...peddlrNotificationMethods,
    async submitNotification() {
      this.submitted = true;
      this.$v.$touch();

      if (this.$v.$invalid) {
        // return;
      }

      this.action = this.notification.id == 0 ? "create" : "update";
      let action = this.action == "create" ? "Create" : "Update";
      this.notification.module = this.notification.module.value
      this.notification.smsStatus = this.notification.smsStatus ? 1 : 0;
      this.notification.appInboxStatus = this.notification.appInboxStatus ? 1 : 0;

      await this.notificationAction({ action: this.action, ...this.notification })
        .then(async () => {
          Swal.fire(`${action} Successful!`, `Notification has been ${this.action}d`, "success");
          this.submitted = false;
          this.$router.push({ name: "Notification Dashboard" });
        })
        .catch((error) => {
          Swal.fire(`${action} Failed!`, `An error occured on notification submission: ${error.data.message}`, "error");
        });
    },
    addTag(newTag) {
      const tag = {
        value: newTag,
      }
      this.moduleOptions.push(tag)
      this.notification.module = tag;
    }
  },
  async mounted() {
    this.notification.id = this.$route.params.id;
    this.changeTitle({ title: "Notification Form" });
    this.changeBreadCrumb({
      breadCrumbs: [
        { text: "Peddlr", to: { name: "Home" } },
        { text: "Notification", to: { name: "Notification Dashboard" } },
        { text: "Form", to: { name: "" } },
      ],
    });

    await this.listPeddlrNotificationModules();

    if (this.notification.id > 0) {
      await this.getPeddlrNotificationDetails({ id: this.notification.id }).then(() => {
        this.notification.module = { value: this.peddlrNotificationDetails.module };
        this.notification.name = this.peddlrNotificationDetails.name;
        this.notification.smsContent = this.peddlrNotificationDetails.sms_content;
        this.notification.appInboxContent = this.peddlrNotificationDetails.app_inbox_content;
        this.notification.smsStatus = this.peddlrNotificationDetails.sms_status ? true : false;
        this.notification.appInboxStatus = this.peddlrNotificationDetails.app_inbox_status ? true : false;
        this.notification.smsSettings = this.peddlrNotificationDetails.sms_setting;
      });
    }
  },
};
</script>

<style scoped>
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

a.disabled {
  pointer-events: none;
}
</style>
